<template>
  <div class="cell-label" @click="onLabelClick">
    {{props.label}}{{active ? "" : "▼"}}
  </div>
  <div class="cell" v-if="active">
    <slot></slot>
  </div>
</template>

<script setup>

import { ref, defineProps } from 'vue';

const props = defineProps({
  label: {
    type: String,
    default: "no label",
    required: false
  },
})

const active = ref(true)

const onLabelClick = e => {
  active.value = !active.value
}

</script>

<style scroped>
.cell {
  border: 1px solid #ccc;
  flex-grow: 1;
  overflow-y: auto;
}

.cell-label {
  background-color: #9dc2db;
  user-select: none;
  border: 2px solid black;
  
}
</style>